export default "__VITE_ASSET__DSYJ5xwn__"